import React from "react";
import "./About.css";
import Portfolio_pic from "../../assets/images/Portfolio pic.jpg";
const About = () => {
  return (
    <>
      <div className="about" id="about">
        <div className="row">
          <div className="col-md-6 about-content">
            {/* <h1>About Me</h1> */}
            <h2 className="col-12 mt-3 mb-1 text-center text-uppercase  ">
              About Me
            </h2>
            <p>
              I am pursuing Btech(2020-24) in computer science from Maharshi
              Dayanand University, India. I have learnt full stack development
              from trusted and experienced teachers of PWskills. I have
              completed various fun as well as complex projects as mentioned
              below , using rich source of youtube and mdn. <br /> Now I want to
              work on full stack projects at professional level.
              <br /> I value time and money. I believe in hard work and
              punctuality. I am looking forward to work on projects which will
              help me to grow and learn more as a developer.
            </p>
          </div>
          <div className="col-md-6 col-xl-6 col-lg-6 col-xs-12 about-img">
            <img src={Portfolio_pic} alt="profile_pic" />
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
